










































































import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { PanelUserService } from '@/modules/user/services/panel-user.service'

@Component({
  components: { BaseButton, Modal, BaseInput, BaseCard }
})
export default class UserProfileNameForm extends Vue {
  constructor(
    private readonly service: PanelUserService
  ) {
    super()
  }

  $refs!: {
    nameUpdateForm: QForm,
  }

  @Prop() username!: string
  @Prop() displayname!: string

  display_name = this.displayname
  displaynameModal = false
  loading = false

  onSubmit() {
    this.$refs.nameUpdateForm.validate().then(success => {
      this.loading = true
      if (success) {
        this.service.updateName({ displayname: this.display_name }).onSuccess(() => {
          this.loading = false
          this.displaynameModal = false
        })
      }
    })
  }

}
